<div id="addPresentationModal">
  <div class="tw-flex tw-justify-end tw-mr-[5px]">
    <button
      type="button"
      mat-icon-button
      class="close"
      (click)="dismiss()"
      aria-label="Close this modal"
    >
      <streamline-icon name="close" width="12" height="12"></streamline-icon>
    </button>
  </div>
  <h4 class="modal-title">Select Presentation</h4>
  <mat-dialog-content>
    <search-filter
      [filterConfig]="filterConfig"
      [search]="search"
      [doSearch]="presentations.doSearch"
    ></search-filter>
    <div
      class="scrollable-list u_margin-sm-top"
      scrollingList
      (scrollEndEvent)="presentations.load()"
      rvSpinner="presentation-list-loader"
      [rvShowSpinner]="presentations.loadingItems"
    >
      <table id="presentationListTable" class="table table--hover">
        <thead class="table-header">
          <tr class="table-header__row">
            <th
              id="tableHeaderName"
              (click)="presentations.sortBy('name')"
              class="table-header__cell u_clickable"
            >
              Name
              <!-- ngIf: search.sortBy == 'name' -->
              @if (search.sortBy === 'name') {
                <i
                  [attr.aria-label]="
                    search.reverse ? 'Descending order' : 'Ascending order'
                  "
                  class="fa"
                  [ngClass]="
                    { false: 'fa-caret-up', true: 'fa-caret-down' }[
                      search.reverse
                    ]
                  "
                ></i>
              }
              <!-- end ngIf: search.sortBy == 'name' -->
            </th>
            <th id="tableHeaderStatus" class="table-header__cell text-right">
              Status
            </th>
          </tr>
        </thead>
        <tbody class="table-body">
          @for (presentation of presentations.items.list; track presentation) {
            <tr
              class="table-body__row u_clickable"
              (click)="select(presentation)"
            >
              <td class="table-body__cell">
                <a rv-link id="presentationName" class="u_ellipsis-lg"
                  ><strong>{{ presentation.name }}</strong></a
                >
              </td>
              <td class="table-body__cell text-right">
                <status-badge [status]="presentation.revisionStatusName" />
              </td>
            </tr>
          }
          <!-- If no presentation available -->
          <tr
            class="table-body__row"
            [shown]="
              !presentations.loadingItems &&
              presentations.items.list.length === 0 &&
              !search.query
            "
          >
            <td colspan="2" class="text-center">
              Add a presentation to start communicating better with your
              audience!
            </td>
          </tr>
          <!-- If no search results -->
          <tr
            class="table-body__row"
            [shown]="presentations.items.list.length === 0 && search.query"
          >
            <td colspan="2" class="text-center">
              Your search didn't return any results.
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions align="end" class="tw-gap-2.5 tw-pt-5">
    <button
      rv-button
      variant="secondary"
      id="cancel"
      type="button"
      (click)="dismiss()"
    >
      Cancel
    </button>
    <!-- Note: The "Select" button is implicitly handled by clicking the row in this component -->
  </mat-dialog-actions>
</div>
